module.exports = __webpack_public_path__ + "img/bg-ana-oarga.038a01d5.jpg";